import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
const Seo = ({
    title,
    description,
    canonical,
    image,
    keywords,
    robots = 'index,follow',
    ogType = 'website',
    siteName,
    locale = 'en_US',
    jsonLd,
    meta = [],
}) => {
    const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

    return (
        <Helmet>
            <html lang="en" />
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="robots" content={robots} />
            {canonical && <link rel="canonical" href={canonical} />}
            {meta.map((m, i) =>
                m.property ? (
                    <meta key={`meta-${i}`} property={m.property} content={m.content} />
                ) : (
                    <meta key={`meta-${i}`} name={m.name} content={m.content} />
                ),
            )}
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            <meta property="og:type" content={ogType} />
            <meta property="og:locale" content={locale} />
            <meta property="og:site_name" content={siteName} />
            {canonical && <meta property="og:url" content={canonical} />}
            {image && <meta property="og:image" content={image} />}
            <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />

            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            {image && <meta name="twitter:image" content={image} />}
            {jsonLdList.map((schema, i) => (
                <script key={`jsonld-${i}`} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    )
}

export default Seo
